export default __webpack_public_path__ + "static/media/figure6.5352fe93.png";